"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const elements_ui_utils_1 = require("@hydrogen/elements.ui.utils");
const ContentBoxContent = (props) => (react_1.default.createElement("div", { className: (0, elements_ui_utils_1.classNames)('p-4 sm:px-6', props.className || '') }, props.children));
exports.default = ContentBoxContent;
//# sourceMappingURL=ContentBoxContent.js.map